import { MdOutlineShare } from "react-icons/md"
import { IMediaAndContent } from "../../interfaces/MediaAndContent"
import Button from "../Buttons/Button"
import DateWithIcon from "../Common/DateWithIcon"
import ChipsMapper from "../Mappers/ChipsMapper"
import { useState } from "react"
import Dialog from "../Dialog/Dialog"
import Share from "../Share/Share"
import DownloadPDFWithFetch from "../DownloadPDF/DownloadPDFWithFetch"

const MediaAndContentWithDownload = ({ imagen, titulo, descripcion, fecha, categorias, pdf, url }: IMediaAndContent) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
    }
  }

  return (
    <>
      <div
        className='gap-4 sm:gap-0 w-[20.5rem] sm:w-full rounded-[12px] flex flex-col sm:flex-row cursor-auto group'
        tabIndex={0}
        role="button"
        onKeyDown={handleKeyDown}
      >
        <div className='overflow-hidden rounded-sm h-[29.01rem] sm:h-[20.375rem] w-full sm:w-[14.4375rem] border border-system-light-50 border-system-light-20 flex-shrink-0'>
          <img
            src={imagen}
            className='w-full h-full object-cover object-center'
          />
        </div>
        <div className='px-4 pt-4 pb-6 sm:pb-4 flex flex-col gap-2 justify-between sm:justify-start max-h-[20.5525rem] sm:max-h-contain w-full xl:min-w-[18.875rem]'>
          <div className="flex flex-col gap-2 ">
            <h4 className='text-tintermedium text-sistem-light-100 max-h-[5.25rem] line-clamp-3'>{titulo}</h4>
            <ChipsMapper categorias={categorias} />
            <p className='text-bsmall text-sistem-light-100 max-h-[20.1875rem] line-clamp-5'>{descripcion}</p>
            <DateWithIcon date={fecha} />
          </div>
          <div className="flex gap-2">
            {
              pdf && pdf?.length > 0
              && <DownloadPDFWithFetch
                fileName={pdf}
                label="Descargar"
                source='Informes'
                module='Informes'
                iconSize={18}
                className="items-center justify-center"
                variant="outline-orange"
              />
            }
            <Button
              label=''
              as='link'
              icon={MdOutlineShare}
              className='text-brand-orange-20 border border-brand-orange-20 rounded-sm'
              showIconLeft={true}
              showIconRight={false}
              iconSize={18}
              onClick={() => setIsOpen(!isOpen)}
              variant="outline-orange"
            />
          </div>
        </div>
      </div>
      <Dialog isOpen={isOpen} toggle={() => setIsOpen(!isOpen)}>
        <Share
          newsTitle={titulo}
          newsUrl={url ? url : ''}
          description={descripcion}
        />
      </Dialog>
    </>
  )
}

export default MediaAndContentWithDownload